export const PRIDE_CHEMICALS_SITE_ID = '698d239b9742c79b2f8cb1f2';
